import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faVolumeHigh,
  faVolumeMedium,
  faVolumeLow,
  faVolumeOff,
} from "@fortawesome/sharp-light-svg-icons"
import ControlButton from "./ControlButton"

const SwitchedVolumeIcon = ({ volume }) => {
  if (volume < 0.3) {
    return <FontAwesomeIcon icon={faVolumeLow} size="1x" className="w-5" />
  } else if (volume < 0.6) {
    return <FontAwesomeIcon icon={faVolumeMedium} size="1x" className="w-5" />
  } else {
    return <FontAwesomeIcon icon={faVolumeHigh} size="1x" className="w-5" />
  }
}

const ControlVideoVolume = ({
  className,
  volume,
  setVolume,
  muted,
  setMuted,
}) => {
  const handleVolumeChange = (e) => {
    setVolume(parseFloat(e.target.value))
  }

  return (
    <div className={`${className} flex group transition-colors duration-300`}>
      <ControlButton
        onClick={() => setMuted(!muted)}
        className="group-hover:bg-ro-gray-850 group-hover:border-ro-gray-850"
      >
        {muted ? (
          <FontAwesomeIcon icon={faVolumeOff} size="1x" className="w-5" />
        ) : (
          <>
            <SwitchedVolumeIcon volume={volume} />
          </>
        )}
      </ControlButton>
      <div className="h-12 flex items-center justify-center relative w-0 overflow-hidden transition-all duration-300 group-hover:w-20 group-hover:bg-ro-gray-850 group-hover:pr-4">
        <input
          className="h-4 w-16 block cursor-pointer appearance-none rounded-md bg-transparent [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:bg-transparent [&::-webkit-slider-thumb]:w-1 [&::-webkit-slider-thumb]:h-1 [&::-moz-range-progress]:appearance-none [&::-moz-range-progress]:bg-transparent [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:bg-transparent [&::-moz-range-thumb]:border-none [&::-moz-range-thumb]:w-1 [&::-moz-range-thumb]:h-1"
          type="range"
          min={0}
          max={1}
          step="any"
          value={volume}
          onChange={handleVolumeChange}
        />
        <div className="h-1 w-16 bg-ro-gray-500 absolute block pointer-events-none">
          <progress
            className={`h-1 w-16 appearance-none absolute bg-transparent [&::-webkit-progress-bar]:h-1 [&::-webkit-progress-value]:h-1 [&::-webkit-progress-bar]:bg-transparent [&::-webkit-progress-value]:bg-ro-gray-50 [&::-moz-progress-bar]:bg-ro-gray-50`}
            max="1"
            step="any"
            value={volume}
          ></progress>
        </div>
      </div>
    </div>
  )
}

export default ControlVideoVolume
